/**
 * Custom error class when no location was found.
 */
export class NoLocationFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "NoLocationFoundError";
    Object.setPrototypeOf(this, NoLocationFoundError.prototype);
  }
}
